import script from "./HoursBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./HoursBarChart.vue?vue&type=script&setup=true&lang=js"

import "./HoursBarChart.vue?vue&type=style&index=0&id=218f5d8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218f5d8a"]])

export default __exports__